import fetch, {getBlob, postFrom} from '../utils/fetch';

//
export function getClockinRecord(params) {
    return fetch({
        method: 'POST',
        url: '/clockin/getClockinRecord',
        data:params
    })
}

export function getClockinRecordlist(params) {
    return fetch({
        method: 'POST',
        url: '/clockin/getClockinRecordlist',
        data:params
    })
}

// 合同列表数量查询
export function checkClockCount(data) {
    return fetch({
        method:'POST',
        url:'clockin/checkClockCount',
        data
    })
}

export function exportClockinList(data) {
    return getBlob({
        method:'POST',
        url:'clockin/exportClockinList',
        data
    })
}

// findClockinRecordStatics
export function findClockinRecordStatics(data) {
    return fetch({
        method:'POST',
        url:'clockin/findClockinRecordStatics',
        data
    })
}

